import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { queryKeys, staleTimes } from '../config/queryClient';

/**
 * Hook para obtener la configuración de una sucursal
 * (estado de pedidos, delivery, precios, etc.)
 * 
 * @param {number} shopBranchId - ID de la sucursal
 * @param {object} options - Opciones adicionales
 * @returns {object} - { data: config, isLoading, error }
 */
export const useBranchConfig = (shopBranchId, options = {}) => {
  return useQuery({
    queryKey: queryKeys.branchConfig(shopBranchId),
    
    queryFn: async () => {
      const response = await axios.get(
        process.env.REACT_APP_API_MODULES_CONFIGS_CARTA_ROUTE,
        {
          params: {
            shopBranchId,
          },
        }
      );
      return response.data;
    },
    
    enabled: !!shopBranchId,
    
    staleTime: staleTimes.realtime,
    
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    
    cacheTime: 10 * 60 * 1000, // 10 minutos
    
    ...options,
  });
};
